import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "../config/brand";
import { useT, LanguageToggle } from "../components/home/i18n";

const HERO = "https://static.prod-images.emergentagent.com/jobs/60e23e87-a848-4e93-8891-7ae69bc71808/images/e643d7db53af76ae98eb6d33cdedf98948322cd88a78d68cef06771faddb19ec.jpeg";

export function BrandMark({ light }) {
  return (
    <Link to="/" data-testid="brand-mark" className="flex items-center gap-2">
      <div className={`flex h-8 w-8 items-center justify-center rounded-sm text-[13px] font-bold ${light ? "bg-[#C4A46B] text-[#173A2C]" : "bg-[#1F4A38] text-[#C4A46B]"}`}>{BRAND.shortName}</div>
      <span className={`font-serif text-xl leading-none ${light ? "text-white" : "text-[#173A2C]"}`}>{BRAND.name}</span>
    </Link>
  );
}

// Split-screen shell for auth pages: brand imagery left, form right.
export default function AuthLayout({ title, subtitle, children, testid }) {
  const { t } = useT();
  return (
    <div data-testid={testid} className="grid min-h-screen bg-[#FDFBF7] lg:grid-cols-2">
      <div className="relative hidden lg:block">
        <img src={HERO} alt="A groomer working calmly with a horse" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#173A2C]/60" />
        <div className="grain absolute inset-0 opacity-20" />
        <div className="relative flex h-full flex-col justify-between p-12">
          <BrandMark light />
          <div>
            <h2 className="max-w-md font-serif text-4xl font-light leading-tight text-white">{t.auth.sideTitle}</h2>
            <p className="mt-4 max-w-sm text-sm text-white/80">{t.auth.sideText}</p>
          </div>
          <p className="text-xs text-white/60">{t.footer.note}</p>
        </div>
      </div>

      <div className="flex flex-col px-6 py-8 sm:px-12 lg:px-16">
        <div className="mx-auto flex w-full max-w-md items-center justify-between">
          <div className="lg:hidden"><BrandMark /></div>
          <div className="ml-auto"><LanguageToggle testid="auth-lang-toggle" variant="dark" /></div>
        </div>
        <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center py-8">
          <span className="text-[11px] font-semibold uppercase tracking-[0.25em] text-[#C4A46B]">{t.auth.tagline}</span>
          <h1 className="mt-2 font-serif text-3xl text-[#173A2C]">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-[#5C5855]">{subtitle}</p>}
          <div className="mt-7">{children}</div>
        </div>
      </div>
    </div>
  );
}
